import { render, staticRenderFns } from "./listagemModelos.vue?vue&type=template&id=fccc55f8&scoped=true&lang=pug&"
import script from "./listagemModelos.vue?vue&type=script&lang=js&"
export * from "./listagemModelos.vue?vue&type=script&lang=js&"
import style0 from "./listagemModelos.vue?vue&type=style&index=0&id=fccc55f8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fccc55f8",
  null
  
)

export default component.exports